import type { DataTableProps } from '#layers/ui/public';

export const listingTablePresentationProps = {
	bordered: false,
	sticky: true,
	ui: {
		tr: 'h-10 [--data-table-row-height:40px]',
		td: 'py-0',
	},
} as const satisfies Pick<DataTableProps<Record<string, unknown>>, 'bordered' | 'sticky' | 'ui'>;

export const listingTablePaginationClass = 'relative z-1 -mt-px border-t';
